/**
 * Get endpoints configuration from window object
 */

// @ts-ignore
export const getSETTINGS = (prop?: string) => {
  if (prop) {
    // @ts-ignore
    return window?.SkyFoundationSettings?.SETTINGS[prop] || {};
  } else {
    // @ts-ignore
    return window?.SkyFoundationSettings?.SETTINGS || {};
  }
};
